export default __webpack_public_path__ + "static/media/2.fd6aabc4.svg";